const SMS_COUNTDOWN = 60;
const IMG_SRC = {
  rightArrow:
    'https://baike-med-1256891581.file.myqcloud.com/2021031/994b95a0-8608-11eb-87da-a34c0caadeed_0.png',
  selected:
    'https://baike-med-1256891581.file.myqcloud.com/2021033/9b6b4150-8608-11eb-947c-032fa08bea6e_0.png',
  unSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/a1815480-8608-11eb-87da-a34c0caadeed_0.png',
  delete:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/c1ee6aa0-8608-11eb-87da-a34c0caadeed_0.png',
  webSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/a5802070-8608-11eb-947c-032fa08bea6e_0.png',
  webUnSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/a5a77e90-8608-11eb-947c-032fa08bea6e_0.png',
  bgWhite:
    'https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png',
  export:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/c28e0600-8608-11eb-947c-032fa08bea6e_0.png',
  back: 'https://baike-med-1256891581.file.myqcloud.com/2021032/b9387f40-8608-11eb-947c-032fa08bea6e_0.png',
  logo: 'https://baike-med-1256891581.file.myqcloud.com/2021034/c2c5dee0-8608-11eb-947c-032fa08bea6e_0.png',
  bottomArrow:
    'https://baike-med-1256891581.file.myqcloud.com/2021034/beb47550-8608-11eb-947c-032fa08bea6e_0.png',
  publishSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021037/99481330-8608-11eb-947c-032fa08bea6e_0.png',
  dataSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021039/c1c02eb0-8608-11eb-87da-a34c0caadeed_0.png',
  userSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021036/a5246be0-8608-11eb-87da-a34c0caadeed_0.png',
  setSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021034/9c6f1cc0-8608-11eb-947c-032fa08bea6e_0.png',
  dataUnSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021034/c1821440-8608-11eb-87da-a34c0caadeed_0.png',
  publishUnSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021039/994d9170-8608-11eb-947c-032fa08bea6e_0.png',
  setUnSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021034/9f2c6800-8608-11eb-947c-032fa08bea6e_0.png',
  userUnSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021035/a524ba00-8608-11eb-87da-a34c0caadeed_0.png',
  up: 'https://baike-med-1256891581.file.myqcloud.com/2021031/a1804310-8608-11eb-87da-a34c0caadeed_0.png',
  down: 'https://baike-med-1256891581.file.myqcloud.com/2021034/c20c2bd0-8608-11eb-87da-a34c0caadeed_0.png',
  ashcan:
    'https://baike-med-1256891581.file.myqcloud.com/2021035/bdded5d0-8608-11eb-947c-032fa08bea6e_0.png',
  loginBg:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/c6378600-8608-11eb-947c-032fa08bea6e_0.jpg',
  loginPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/c59f3da0-8608-11eb-947c-032fa08bea6e_0.png',
  setPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/a08c4620-8608-11eb-947c-032fa08bea6e_0.png',
  adminSetPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021035/bfc8cb80-8608-11eb-947c-032fa08bea6e_0.png',
  strategyPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021032/a570b720-8608-11eb-87da-a34c0caadeed_0.png',
  publishPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021039/a070cee0-8608-11eb-947c-032fa08bea6e_0.png',
  publicPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021032/c62b7810-8608-11eb-947c-032fa08bea6e_0.png',
  dataCenterPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021038/c416a1d0-8608-11eb-87da-a34c0caadeed_0.png',
  userPage:
    'https://baike-med-1256891581.file.myqcloud.com/2021032/a6b0d840-8608-11eb-87da-a34c0caadeed_0.png',
  bg: 'https://baike-med-1256891581.file.myqcloud.com/2021034/c00c8b40-8608-11eb-947c-032fa08bea6e_0.png',
  roundSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021031/9a58bfe0-8608-11eb-947c-032fa08bea6e_0.png',
  roundUnSelected:
    'https://baike-med-1256891581.file.myqcloud.com/2021033/99996780-8608-11eb-87da-a34c0caadeed_0.png',
  line: 'https://baike-med-1256891581.file.myqcloud.com/2021033/c2a3b0e0-8608-11eb-947c-032fa08bea6e_0.png',
  blockLine:
    'https://baike-med-1256891581.file.myqcloud.com/2021032/b8733370-8608-11eb-87da-a34c0caadeed_0.png',
  exampleImg:
    'https://baike-med-1256891581.file.myqcloud.com/2021036/c79fa180-8608-11eb-87da-a34c0caadeed_0.png',
  noDataPurple:
    'https://baike-med-1256891581.file.myqcloud.com/2021034/c62b5100-8608-11eb-947c-032fa08bea6e_0.png',
  redMark:
    'https://baike-med-1256891581.file.myqcloud.com/2021036/99599f60-8608-11eb-87da-a34c0caadeed_0.png',
  selectBlue:
    'https://baike-med-1256891581.file.myqcloud.com/2021030/999a2ad0-8608-11eb-87da-a34c0caadeed_0.png',
  previewImgDoctor:
    'https://baike-med-1256891581.file.myqcloud.com/2021040/61407370-980e-11eb-a92f-f3736434eb7a_0.png',
  previewImgDeputy:
    'https://baike-med-1256891581.file.myqcloud.com/2021044/6104f110-980e-11eb-9e88-91a002bdcd2f_0.png',
  doctorDefault:
    'https://baike-med-1256891581.file.myqcloud.com/2021043/416babd0-9d97-11eb-87f5-87f8260230cc_0.png',

  // 企业微信设置
  agentSet: {
    one: 'https://baike-med-1256891581.file.myqcloud.com/2021048/4be9a170-a283-11eb-ae0e-21d0e54b35ac_0.png',
    two: 'https://baike-med-1256891581.file.myqcloud.com/2021043/4c053fc0-a283-11eb-ae0e-21d0e54b35ac_0.png',
    three:
      'https://baike-med-1256891581.file.myqcloud.com/2021044/472ba430-a283-11eb-87f5-87f8260230cc_0.png',
    four: 'https://baike-med-1256891581.file.myqcloud.com/2021041/243795c0-a8bd-11eb-9f82-2f36b21da993_0.png',
  },
  applicationManagement:
    'https://baike-med-1256891581.file.myqcloud.com/2021044/441d52c0-a283-11eb-87f5-87f8260230cc_0.png',
  dialogueIcon:
    'https://baike-med-1256891581.file.myqcloud.com/2021041/7c9be710-a701-11eb-ae0e-21d0e54b35ac_0.png',
  audio:
    'https://baike-med-1256891581.file.myqcloud.com/2021044/1fb0ae10-a8bd-11eb-9f82-2f36b21da993_0.png',
  question:
    'https://baike-med-1256891581.file.myqcloud.com/2021053/cc3c50c0-b48f-11eb-9f82-2f36b21da993_0.png',
  docTypeImg: {
    doc: 'https://baike-med-1256891581.file.myqcloud.com/2021073/1ff01730-f12e-11eb-956b-c525d6c0c8cb_0.svg',
    pdf: 'https://baike-med-1256891581.file.myqcloud.com/2021070/2b7946d0-f12e-11eb-b727-2966ebe1cd85_0.svg',
    ppt: 'https://baike-med-1256891581.file.myqcloud.com/2021076/309b8420-f12e-11eb-956b-c525d6c0c8cb_0.svg',
    default:
      'https://baike-med-1256891581.file.myqcloud.com/2021072/355821d0-f12e-11eb-956b-c525d6c0c8cb_0.svg',
  },
};

// 横幅banner类型
const BannerEntryType = {
  doctor: {
    name: 1,
    text: '医生端',
  },
  deputy: {
    name: 2,
    text: '代表端',
  },
  h5: {
    name: 3,
    text: 'H5渠道',
  },
};

const APP_TYPE = {
  officialAccounts: 1, // 公众号
  miniprogram: 2, // 小程序
  H5: 3,
  other: 4,
};
const PHONE_REG = /^1[3456789]\d{9}$/;

const PAGE_SIZE = 10;

const PAGE_SIZES = [10, 20, 50, 100];
const MENU_ROUTE = {
  meetingData: ['meetingDataDetail', 'meetingOrganizersDetail'],
  operationManagement: ['operationManagementEdit'],
  externalContactManagement: ['externalContactManagementRecords'],
  doctorManagement: ['doctorInfo'],
  representManagement: ['representDetaill'],
  hospitalManagement: ['hospitalDetail'],
  MessageList: ['userMessageList'],
  artilceList: ['addArtilce'],
  rosterList: ['rosterDetail'],
  strategySetting: ['strategyView'],
  voteManagement: ['votingDetail', 'addVoting'],
  applicationManagement: ['applicationDetail'],
  chattingRecords: ['conversationView', 'sensitiveWords'],
  materialManagement: [
    'material-img-upload',
    'material-audio-upload',
    'material-video-upload',
    'docDetail',
  ],
};
export {
  SMS_COUNTDOWN,
  IMG_SRC,
  BannerEntryType,
  APP_TYPE,
  PHONE_REG,
  PAGE_SIZE,
  PAGE_SIZES,
  MENU_ROUTE,
};
